import { createSelector, Selector } from '@ngrx/store'
import { selectCustomChannelAsSources } from '@tokeet-frontend/channels'
import { Channel, selectFormChannels } from '@tokeet/tv3-platform'
import * as lodash from 'lodash'
import { State } from '../state'

export const selectBookingSourcesWithCustomChannels = (custom: { inquirySource: string }, includeSource?: boolean) =>
  createSelector(
    selectFormChannels(custom, includeSource),
    selectCustomChannelAsSources,
    (channels: { id: string; name: string; label: string }[], customChannels) => {
      return lodash.sortBy([...channels, ...customChannels], (t) => lodash.toLower(t.label))
    }
  )

export const selectChannelsWithCustomChannels = (
  selector: Selector<State, Channel[]>,
  field: 'name' | 'token' = 'name'
) =>
  createSelector(
    selector,
    selectCustomChannelAsSources,
    (channels, customChannels): { id: string; name: string; label: string }[] => {
      const items = channels.map((c) => ({
        id: lodash.get(c, field),
        name: lodash.get(c, field),
        label: c.friendlyName,
      }))
      return lodash.sortBy([...items, ...customChannels], (t) => lodash.toLower(t.label))
    }
  )
